import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AnalyticsCommandCenter from './pages/analytics-command-center';
import TrustAndVerificationHub from './pages/trust-and-verification-hub';
import BrandCampaignStudio from './pages/brand-campaign-studio';
import CommunityShowcase from './pages/community-showcase';
import ContentCreationSuite from './pages/content-creation-suite';
import CreatorDashboard from './pages/creator-dashboard';
import Homepage from './pages/homepage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        
        <Route path="/" element={<Homepage />} />
        {/* Define your route here 
        <Route path="/analytics-command-center" element={<AnalyticsCommandCenter />} />
        <Route path="/trust-and-verification-hub" element={<TrustAndVerificationHub />} />
        <Route path="/brand-campaign-studio" element={<BrandCampaignStudio />} />
        <Route path="/community-showcase" element={<CommunityShowcase />} />
        <Route path="/content-creation-suite" element={<ContentCreationSuite />} />
        <Route path="/creator-dashboard" element={<CreatorDashboard />} />
        <Route path="/homepage" element={<Homepage />} />*/}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
